/**
 * 启用与停用状态
 */
import React from 'react';
import { Modal, message, } from 'antd';
import PropTypes from 'prop-types';
import styles from './PopconfirmModal.module.scss';
import http from '@/assets/api/http';
import { ExclamationCircleOutlined } from '@ant-design/icons';


const { confirm } = Modal;

class Confirm extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    _handleOk = () => {
        const { data } = this.props;
        http('/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.quickUpdateCoupon', {
            id: data.id,
            status: data.switchState,
        }, 'POST').then(() => {
            message.success('修改成功');
            this.props.closeMode(true);
        }).catch((e = {}) => {
            message.error(e.message || '修改异常');
        });
    }

    _handleCancel = () => {
        this.props.closeMode();
    }

    showConfirm = () => {
        const { data, } = this.props;
        let that = this;
        confirm({
            destroyOnClose: true,
            centered: true,
            title: '温馨提示',
            icon: <ExclamationCircleOutlined />,
            content: <>
                <div className={styles.container}>
                    <div className={styles.title}>
                        <h4>确定要{data.status == '1' ? '暂停' : '开启'}此卡券吗？</h4>
                    </div>
                    <span>你还要继续吗？</span>
                </div>
            </>,
            onOk() {
                that._handleOk();
            },
            onCancel() {
                that._handleCancel();
            },
        });
    }


    render() {
        return <>{this.showConfirm()}</>;
    }
}

Confirm.propTypes = {
    data: PropTypes.object, // 弹框入参
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default Confirm;